import React from 'react';
import '../PricingSection.css';

const AuditedPricingSection: React.FC = () => {
  const pricingPlans = [
    {
      name: "Zajecia Grupowe",
      price: "65",
      period: "PLN/60 minut",
      description: "Zajecia grupowe dostosowane do poziomu ucznia",
      features: [
        "Zajecia grupowe (3-6 osob)",
        "Rozne poziomy zaawansowania",
        "Szkola podstawowa",
        "Szkola srednia",
        "Przygotowanie do egzaminow",
        "Materialy dydaktyczne w cenie",
        "Wsparcie miedzy zajeciami"
      ],
      highlighted: false,
      buttonText: "Wybierz grupowe"
    },
    {
      name: "Zajecia Indywidualne",
      price: "150",
      period: "PLN/60 minut",
      description: "Zajecia indywidualne - przygotowanie do matury i egzaminu osmoklasisty",
      features: [
        "Zajecia 1:1 z nauczycielem",
        "Przygotowanie do matury",
        "Przygotowanie do egzaminu osmoklasisty",
        "Elastyczne terminy",
        "Spersonalizowany program nauki",
        "Intensywne wsparcie",
        "Monitoring postepow"
      ],
      highlighted: true,
      buttonText: "Wybierz Bestseler"
    },
    {
      name: "Indywidualne Potrzeby",
      price: "Wycena indywidualna",
      period: "",
      description: "Specjalna opieka, konkursy matematyczne i intensywna nauka - daj znac w formularzu",
      features: [
        "Przygotowanie do konkursow",
        "Olimpiady matematyczne",
        "Specjalna opieka pedagogiczna",
        "Kursy wakacyjne",
        "Bardzo intensywny okres przygotowawczy",
        "Konsultacje rodzinne"
      ],
      highlighted: false,
      buttonText: "Skontaktuj sie"
    }
  ];

  const handlePlanSelect = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="pricing-section">
      <div className="pricing-container">
        <div className="section-header">
          <h2>Cennik Naszych Zajec</h2>
          <p>Wybierz pakiet dostosowany do Twoich potrzeb i budzetu</p>
        </div>

        <div className="pricing-grid">
          {pricingPlans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.highlighted ? 'highlighted' : ''}`}>
              {plan.highlighted && <div className="popular-badge">Najpopularniejszy</div>}

              <div className="plan-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  <span className="price">{plan.price}</span>
                  {plan.period && <span className="period">{plan.period}</span>}
                </div>
                <p className="plan-description">{plan.description}</p>
              </div>

              <ul className="plan-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="checkmark">V</span>
                    {feature}
                  </li>
                ))}
              </ul>

              <button
                className={`plan-button ${plan.highlighted ? 'highlighted' : ''}`}
                onClick={handlePlanSelect}
              >
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AuditedPricingSection;
